import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

interface ThemeToggleProps {
  className?: string;
  showLabel?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '', showLabel = false }) => {
  const { theme, themeMode, setThemeMode } = useTheme();

  const handleClick = () => {
    // Ciclo: auto -> light -> dark -> auto
    if (themeMode === 'auto') {
      setThemeMode('light');
    } else if (themeMode === 'light') {
      setThemeMode('dark');
    } else {
      setThemeMode('auto');
    }
  };

  const getIcon = () => {
    if (themeMode === 'auto') {
      return '⚪'; // Auto
    }
    return theme === 'light' ? '☀️' : '🌙';
  };

  const getTitle = () => {
    if (themeMode === 'auto') {
      return 'Modo automático (sigue al sistema)';
    }
    return theme === 'light' ? 'Modo claro (manual)' : 'Modo oscuro (manual)';
  };

  const getLabel = () => {
    if (themeMode === 'auto') {
      return `Auto (${theme === 'light' ? 'Claro' : 'Oscuro'})`;
    }
    return theme === 'light' ? 'Modo claro' : 'Modo oscuro';
  };

  return (
    <button
      onClick={handleClick}
      className={`theme-toggle ${className} ${themeMode === 'auto' ? 'auto-mode' : ''}`}
      title={getTitle()}
      aria-label={getTitle()}
    >
      <div className="theme-toggle-track">
        <div className="theme-toggle-thumb">
          <span className="theme-icon">
            {getIcon()}
          </span>
        </div>
      </div>
      {showLabel && (
        <span className="theme-label">
          {getLabel()}
        </span>
      )}
    </button>
  );
};

export default ThemeToggle;